"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (e, t) {
  for (var i in t) {
    e[i] = t[i];
  }
}(exports, function (e) {
  var t = {};function i(n) {
    if (t[n]) return t[n].exports;var r = t[n] = { i: n, l: !1, exports: {} };return e[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
  }return i.m = e, i.c = t, i.d = function (e, t, n) {
    i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
  }, i.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, i.t = function (e, t) {
    if (1 & t && (e = i(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var n = Object.create(null);if (i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var r in e) {
      i.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
    }return n;
  }, i.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return i.d(t, "a", t), t;
  }, i.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, i.p = "", i(i.s = 249);
}({ 0: function _(e, t) {
    e.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(e, t) {
          var i = void 0;"function" == typeof Event ? i = new Event(t) : (i = document.createEvent("Event"), i.initEvent(t, !0, !0)), e.dispatchEvent(i);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(e, t) {
          return t ? document.querySelector("[" + e + "=\"" + t + "\"]") : document.querySelector("[" + e + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(e, t) {
          return t ? document.querySelectorAll("[" + e + "=\"" + t + "\"]") : document.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(e, t, i) {
          return i ? e.querySelector("[" + t + "=\"" + i + "\"]") : e.querySelector("[" + t + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(e) {
          return Array.prototype.slice.call(e.parentElement.querySelectorAll(":hover")).filter(function () {
            return e[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(e, t, i) {
          return i ? e.querySelectorAll("[" + t + "=\"" + i + "\"]") : e.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(e, t) {
          return e.querySelector("." + t);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(e) {
          var t = void 0;return "function" == typeof Event ? t = new Event(e) : (t = document.createEvent("Event"), t.initEvent(e, !0, !0)), t;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(e) {
          var t = void 0;if (null != e) if (void 0 === e.code) switch (e.keyCode) {case 13:
              t = "Enter";break;case 38:
              t = "ArrowUp";break;case 40:
              t = "ArrowDown";break;case 8:
              t = "Backspace";break;case 9:
              t = "Tab";break;case 27:
              t = "Escape";break;case 33:
              t = "PageUp";break;case 34:
              t = "PageDown";break;case 32:
              t = "Space";break;default:
              t = void 0;} else t = e.code;return t;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(e) {
          return [].concat(_toConsumableArray(e.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (e) {
            return !function (e) {
              return "hidden" === window.getComputedStyle(e).visibility;
            }(e) && !e.hasAttribute("disabled") && !e.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 2: function _(e, t, i) {
    "use strict";
    var n = i(0),
        r = i.n(n);t.a = function (e, t, i) {
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var o = r.a.getKeyboardFocusableElements(t),
          a = o[0],
          s = o[o.length - 1];if (i) {
        if (s.tagName && "IFRAME" === s.tagName) {
          var _e = document.createElement("div");_e.setAttribute("tabindex", "0"), s.parentNode.insertBefore(_e, s.nextSibling);
        }if (a.tagName && "IFRAME" === a.tagName) {
          var _e2 = document.createElement("div");_e2.setAttribute("tabindex", "0"), s.parentNode.insertBefore(_e2, s.nextSibling), a.parentNode.insertBefore(_e2, a);
        }n < 1 && (e.preventDefault(), setTimeout(function () {
          a.focus();
        }, 100)), e.shiftKey ? document.activeElement === a && (e.preventDefault(), s.focus()) : document.activeElement === s && (e.preventDefault(), a.focus());
      }
    };
  }, 249: function _(e, t, i) {
    e.exports = i(250);
  }, 250: function _(e, t, i) {
    "use strict";
    i.r(t), i.d(t, "Video", function () {
      return a;
    });var n = i(0),
        r = i.n(n),
        o = i(2);
    var a = function () {
      function a(e) {
        _classCallCheck(this, a);

        this.element = e, this.modal = r.a.getElementByAttribute(this.attributes.modal, this.element.getAttribute("data-rs-video")), this.iframe = r.a.getElementByAttribute(this.attributes.iframe, this.element.getAttribute("data-rs-video")), this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth, this.scrollPosition = 0, this.bodyMarginTop = this.initializeBodyMarginTop(), this.addEventHandlers(), this.keystroke = 0, this.modalOpen;
      }

      _createClass(a, [{
        key: "initializeBodyMarginTop",
        value: function initializeBodyMarginTop() {
          return "" === document.body.style.marginTop || null === document.body.style.marginTop ? 0 : document.body.style.marginTop.slice(0, document.body.style.marginTop.length - 2);
        }
      }, {
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.element.addEventListener("click", function (e) {
            e.preventDefault(), _this.scrollPosition = window.pageYOffset, _this.toggleModal();
          }), this.modal.addEventListener("click", function (e) {
            e.preventDefault(), _this.toggleModal(), document.body.style.marginTop = _this.bodyMarginTop + "px", window.scrollTo(0, _this.scrollPosition);
          }), document.addEventListener("keydown", function (e) {
            _this.handleButtonKeys(e);
          });
        }
      }, {
        key: "toggleModal",
        value: function toggleModal() {
          this.modal.classList.contains(this.classes.modalActive) ? (this.iframe.setAttribute("src", this.iframe.getAttribute("src")), document.body.style.paddingRight = "0px", this.modal.style.paddingRight = "", this.keystroke = 0, this.modalOpen = !1) : (document.body.style.marginTop = this.bodyMarginTop - this.scrollPosition + "px", document.body.style.paddingRight = this.scrollbarWidth + "px", this.modal.style.paddingRight = this.scrollbarWidth + "px", this.modalOpen = !0), document.querySelector("html").classList.toggle(this.classes.modalOpen), this.modal.classList.toggle(this.classes.modalActive);
        }
      }, {
        key: "handleButtonKeys",
        value: function handleButtonKeys(e) {
          if (null != e) switch (r.a.getKeyCodeOnKeyDownEvent(e)) {case "Escape":
              this.modal.classList.contains(this.classes.modalActive) && (this.toggleModal(), this.element.focus());break;case "Tab":
              this.modalOpen && (Object(o.a)(e, this.modal, this.modalOpen, this.keystroke), this.keystroke++);}
        }
      }, {
        key: "classes",
        get: function get() {
          return { modal: "modal", modalActive: "modal--active", modalOpen: "modal-open", modalOverlayActive: "modal__overlay--active" };
        }
      }, {
        key: "attributes",
        get: function get() {
          return { overlay: "data-rs-video-overlay", modal: "data-rs-video-modal", iframe: "data-rs-video-iframe" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-video]";
        }
      }]);

      return a;
    }();
  } }));